import React from 'react';
import { Modal, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import CommonModalButton from './CommonModalButton';

// ============================================
// CommonDeleteModal
// 공용 삭제 확인 모달 — 중앙 정렬 다이얼로그(제목 + 설명 + 취소/삭제 버튼).
// 프로젝트 곳곳의 일회성 삭제 확인 모달을 표준화하기 위한 공용 컴포넌트.
//
// 사용 예:
//   <CommonDeleteModal
//     open={open}
//     onClose={handleClose}
//     onConfirm={handleDelete}
//     title="직인을 삭제하시겠습니까?"
//     description="삭제한 항목은 복구할 수 없습니다."
//     isLoading={deleteMutation.isPending}
//   />
// ============================================

const Container = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '465px',
  maxWidth: 'calc(100vw - 32px)',
  background: '#fff',
  borderRadius: '16px',
  boxShadow:
    '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  outline: 'none',
});

const TextGroup = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
});

const Title = styled(Typography)({
  fontSize: '22px',
  fontWeight: 600,
  color: '#262626',
  textAlign: 'center',
});

const Description = styled(Typography)({
  fontSize: '15px',
  fontWeight: 400,
  color: '#737373',
  textAlign: 'center',
  lineHeight: 1.5,
});

const ButtonRow = styled('div')({
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
});

const CommonDeleteModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
  // 확인 버튼 색. 삭제가 아닌 확인(출결 처리 등)에는 'submit' 을 넘긴다.
  confirmVariant = 'delete',
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} disableEscapeKeyDown>
      <Container>
        <TextGroup>
          <Title>{title}</Title>
          {description && <Description>{description}</Description>}
        </TextGroup>
        <ButtonRow>
          <CommonModalButton variant="cancel" onClick={onClose}>
            {cancelText || t('취소')}
          </CommonModalButton>
          <CommonModalButton variant={confirmVariant} onClick={onConfirm} disabled={isLoading}>
            {confirmText || t('삭제')}
          </CommonModalButton>
        </ButtonRow>
      </Container>
    </Modal>
  );
};

export default CommonDeleteModal;
